import { StructureMetadataDtoRead } from '@/rtkApi/mddApiSliceGeneratedV2'

import { StructureTreeItem } from './types'

export const CONTAINER_TYPES = ['SYSTEM', 'FOLDER', 'FOLDER_WORKFLOW', 'API_COLLECTION', 'API_NODE', 'TABLE']

export const isFolderType = (type?: string): boolean =>
	type === 'FOLDER' || type === 'FOLDER_WORKFLOW' || type === 'SYSTEM'

export const sortStructures = (a: StructureMetadataDtoRead, b: StructureMetadataDtoRead, alphabetSort = true): number => {
	const aIsFolder = isFolderType(a.type)
	const bIsFolder = isFolderType(b.type)
	if (aIsFolder && !bIsFolder) return -1
	if (!aIsFolder && bIsFolder) return 1
	if (!alphabetSort && a.orderPriority != null && b.orderPriority != null) {
		return a.orderPriority - b.orderPriority
	}
	return (a.name || '').localeCompare(b.name || '')
}

export const sortTreeItems = (a: StructureTreeItem, b: StructureTreeItem): number => {
	const aIsFolder = isFolderType(a.type)
	const bIsFolder = isFolderType(b.type)
	if (aIsFolder && !bIsFolder) return -1
	if (!aIsFolder && bIsFolder) return 1
	return (a.label || '').localeCompare(b.label || '')
}

export const toTreeItem = (structure: StructureMetadataDtoRead): StructureTreeItem => ({
	id: String(structure.id),
	label: structure.name || structure.code || '',
	structureId: structure.id!,
	type: structure.type as StructureTreeItem['type'],
	code: structure.code,
	uuid: structure.uuid,
	fullPath: structure.fullPath,
	status: structure.status,
	parentStructureId: structure.parent?.id,
	orderPriority: structure.orderPriority,
	lockedFor: structure.lockedFor,
	lockedTime: structure.lockedTime,
	lastModifiedBy: structure.lastModifiedBy,
	structurePermissions: structure.permissions,
})

const getAllDescendants = (nodeId: number, childrenMap: Record<number, number[]>): number[] => {
	const children = childrenMap[nodeId]
	if (!children) return []
	return children.flatMap((childId) => [childId, ...getAllDescendants(childId, childrenMap)])
}

export const isFolderFullySelected = (
	nodeId: number,
	selectedNodes: number[],
	childrenMap: Record<number, number[]>,
): boolean => {
	const descendants = getAllDescendants(nodeId, childrenMap)
	return descendants.length === 0
		? selectedNodes.includes(nodeId)
		: descendants.every((id) => selectedNodes.includes(id))
}

export const getFullySelectedNodes = <T extends { type?: string }>(
	selectedNodes: number[],
	childrenMap: Record<number, number[]>,
	nodes: Record<number, T>,
): number[] =>
	selectedNodes.filter((nodeId) => {
		const node = nodes[nodeId]
		if (!node || !CONTAINER_TYPES.includes(node.type || '')) return true
		return isFolderFullySelected(nodeId, selectedNodes, childrenMap)
	})
